// @flow
import type {Element} from 'react'
import React, {Component} from 'react'
import {indexBy, prop} from 'ramda'

import type {PickAlert, UpdateCallback} from 'components/proposals/types'
import util from 'utils/MiscUtils'
import Value from '../../ui/Value'
import SelectPerson from './SelectPerson'
import SelectDate from './SelectDate'
import type {Alert, Person, Role} from '../types'

type Props = {
  assignedUntil: Value,
  availablePeople: Person[],
  isReadonly: boolean,
  person: ?Person,
  role: ?Role,
  onChange: UpdateCallback,
  pickAlert: PickAlert,
}

type State = {
  hasTouchedName: boolean,
  hasTouchedDate: boolean,
}

class Editor extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.indexedPeople = indexBy(prop('databaseId'), props.availablePeople)
    this.state = {
      hasTouchedName: false,
      hasTouchedDate: false,
    }
  }

  onChange: ((path: Array<number | string>, value: string) => void) = (path: Array<number | string>, value: string) => {
    const [fieldName] = path
    const changeValue = () => this.props.onChange(path, value)

    switch (fieldName) {
      case 'person':
        this.setState({hasTouchedName: true}, changeValue)
        return
      case 'assignedUntil':
        this.setState({hasTouchedDate: true}, changeValue)
        return
      default:
        util.warn(`Unknown field type for ${fieldName}`)
        changeValue()
    }
  }

  get roleName(): string {
    return this.props.role ? this.props.role.localizedName : ''
  }

  get assignedUntil(): Value {
    return this.props.assignedUntil
  }

  get personAlert(): ?Alert {
    return this.hasTouched
      ? this.props.pickAlert('personDatabaseId')
      : null
  }

  get assignedUntilAlert(): ?Alert {
    return this.hasTouched
      ? this.props.pickAlert('assignedUntil')
      : null
  }

  get hasTouched(): boolean {
    return this.state.hasTouchedDate && this.state.hasTouchedName
  }

  indexedPeople: Object

  // eslint-disable-next-line react/no-arrow-function-lifecycle
  render: (() => Element<"div">) = () => (
    <div className="refinery-elect-role-filler">
      <div className="form-group">
        <SelectPerson
          alert={this.personAlert}
          availablePeople={this.indexedPeople}
          isReadonly={this.props.isReadonly}
          onChange={this.onChange}
          path={['person']}
          person={this.props.person}
        />
      </div>
      <div className="form-group">
        <SelectDate
          alert={this.assignedUntilAlert}
          date={this.assignedUntil}
          isReadonly={this.props.isReadonly}
          onChange={this.onChange}
          path={['assignedUntil']}
        />
      </div>
    </div>
  )
}

export default Editor
